import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import {useSelector} from "react-redux"


const PrivateRouter = () => {

  const {token,currentUser} = useSelector((state)=>state.auth)



  return (

    token || currentUser ? <Outlet/> : <Navigate to="/"/>

  )
}

export default PrivateRouter